// Module
var code = "<div class=\"col-md-10 col-md-offset-1\"> <h2>Business disabled</h2> <p class=\"lead\"> The business you are associated with is disabled. Please try again later. </p> <p> <button data-bind=\"click: logout\" class=\"btn btn-primary mt-3\">Logout</button> </p> </div>";
// Exports
export default code;